export default "__VITE_ASSET__B1NlWy8e__"